export default __webpack_public_path__ + "static/media/data logo dark.49a76ebb.gif";